/**
 * Props that make a non-button element (card, tile) behave like a button:
 * focusable with Tab, announced as a button, activated with Enter/Space.
 * Usage: <div className="stat-card" {...clickable(() => navigate('/x'))}>
 */
export const clickable = (handler) => ({
  role: 'button',
  tabIndex: 0,
  onClick: handler,
  onKeyDown: (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handler(e);
    }
  },
});
